/**
 * Check if a string is falsey
 * @param value   String checked
 */
export const isValueEmpty = (value: string | null | undefined) => !value?.length;
